var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"NavLinkMobile",attrs:{"exact":!_vm.matchChildrenRoutes,"tag":"li","to":{
    name: _vm.to,
    params: {
      actor: _vm.selectedActor && _vm.selectedActor.pathArr,
      landscapeSlug: _vm.$route.params.landscapeSlug
    }
  }}},[_c('a',[(_vm.svg)?_c('lm-icon',{staticClass:"text-gray-300",attrs:{"icon":_vm.icon,"svg":""}}):_c('lm-material-icon',{attrs:{"icon":_vm.icon}}),_c('span',{staticClass:"Label"},[_vm._v(_vm._s(_vm.label))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }